const testimonials = [
  {
    name: "Marek Kowalski",
    role: "Właściciel firmy — instalacje elektryczne",
    location: "Warszawa i okolice",
    text: "Przed zleceniem miałem tylko profil na Facebooku. Teraz klienci trafiają do mnie z Google i dzwonią od razu po wejściu na stronę. W pierwszym miesiącu kilka nowych zleceń bezpośrednio ze strony.",
    rating: 5,
    avatar: "https://public.readdy.ai/ai/img_res/81f526553c479e3fba4a38b158b1d4b8.jpg",
  },
  {
    name: "Tomasz Wiśniewski",
    role: "Firma brukarsko-ogrodnicza",
    location: "Kraków",
    text: "Strona jest profesjonalna, szybka i świetnie wygląda na telefonie. Klienci często wspominają, że zanim zadzwonili, zobaczyli realizacje na stronie i już wiedzieli, że chcą właśnie ze mną współpracować.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=polish%20male%20construction%20business%20owner%20portrait%2C%20friendly%20smile%2C%20outdoor%20background%2C%2038%20years%20old%2C%20work%20clothes%2C%20professional%20photo&width=120&height=120&seq=avatar_bru_01&orientation=squarish",
  },
  {
    name: "Anna Nowak",
    role: "Serwis klimatyzacji i wentylacji",
    location: "Wrocław",
    text: "Bardzo sprawna realizacja i dobry kontakt. Strona dokładnie taka, jaką chciałam — prosta, konkretna i skuteczna. Widać, że autor rozumie potrzeby firm usługowych, nie tylko projektuje ładne strony.",
    rating: 5,
    avatar: "https://readdy.ai/api/search-image?query=professional%20polish%20businesswoman%20portrait%2C%2035%20years%20old%2C%20service%20business%20owner%2C%20clean%20background%2C%20confident%20smile%2C%20casual%20business%20attire&width=120&height=120&seq=avatar_klim_01&orientation=squarish",
  },
];

const TestimonialsSection = () => {
  return (
    <section id="opinie" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-[#0F2557] text-sm font-semibold tracking-wide uppercase mb-3">
            Opinie
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1A1A2E] mb-5">
            Profesjonalny wizerunek ma znaczenie
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed">
            Sprawdź, co mówią właściciele firm usługowych po współpracy.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t) => (
            <article
              key={t.name}
              className="bg-[#F7F8FA] rounded-xl p-7 flex flex-col gap-5 border border-gray-100"
              itemScope
              itemType="https://schema.org/Review"
            >
              <div className="flex gap-1" itemScope itemType="https://schema.org/Rating" itemProp="reviewRating">
                <meta itemProp="ratingValue" content={String(t.rating)} />
                <meta itemProp="bestRating" content="5" />
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#F59E0B] text-base"></i>
                  </div>
                ))}
              </div>
              <blockquote className="text-gray-600 text-sm leading-relaxed flex-1" itemProp="reviewBody">
                &ldquo;{t.text}&rdquo;
              </blockquote>
              <div
                className="flex items-center gap-3 pt-4 border-t border-gray-200"
                itemScope
                itemType="https://schema.org/Person"
                itemProp="author"
              >
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={`${t.name} — opinia o stronie internetowej dla firmy usługowej`}
                    title={t.role}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-semibold text-[#1A1A2E] text-sm" itemProp="name">{t.name}</p>
                  <p className="text-xs text-gray-400" itemProp="jobTitle">{t.role}</p>
                  <p className="text-xs text-[#0F2557]/60 mt-0.5">
                    <i className="ri-map-pin-line text-xs mr-1"></i>
                    <span itemProp="address">{t.location}</span>
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
